import { mealPlanDefautMessage } from "@/utils/aemDefaultData";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { z } from "zod";

const useValidation = () => {
  const { messages: MESSAGE } = useAppSelector((state) => state.messageSlice);
  const { ERROR_MESSAGE } = MESSAGE;

  const {
    INITIAL_SPACE_ERROR,
    BEGIN_ERROR_MESSAGE,
    END_ERROR_MESSAGE,
    LIST_NAME_EMPTY_MESSAGE,
    LIST_NAME_MIN_CHARACTERS,
    LIST_NAME_MAX_CHARACTERS,
    SPECIAL_CHARACTER_NOT_ALLOWED,
  } = ERROR_MESSAGE;

  const valueWithoutInitalSpace = (val: string) => {
    const regex = /^(?![_-])[A-Za-zÀ-ÿ0-9\s_-]+(?<![_-])$/;
    const schema = z.string().superRefine((val, ctx) => {
      if (!regex.test(val)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "regError",
        });
      }
      if (/^\s/.test(val)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "initialSpaceError",
        });
      }
    });

    const trimmedValue = val.replace(/^\s+/g, "");
    const result = schema.safeParse(val);

    return {
      value: trimmedValue,
      error: {
        regError: result.success
          ? false
          : result.error.errors.some((e) => e.message === "regError"),
        initialSpaceError: result.success
          ? false
          : result.error.errors.some((e) => e.message === "initialSpaceError"),
      },
    };
  };

  const validateInput = (
    value: string,
    regError: boolean,
    initialSpaceError: boolean
  ): string => {
    const validationSchema = z
      .string()
      .refine(() => !initialSpaceError, {
        message: INITIAL_SPACE_ERROR,
      })
      .refine((val) => !/^[_-]/.test(val), {
        message:
          BEGIN_ERROR_MESSAGE ?? mealPlanDefautMessage[0]?.beginErrorMessage,
      })
      .refine((val) => !/[_-]$/.test(val), {
        message: END_ERROR_MESSAGE ?? mealPlanDefautMessage[0]?.endErrorMessage,
      })
      .refine((val) => val.trim().length > 0, {
        message:
          LIST_NAME_EMPTY_MESSAGE ??
          mealPlanDefautMessage[0]?.listNameEmptyMessage,
      })
      .refine((val) => val.trim().length >= 3, {
        message:
          LIST_NAME_MIN_CHARACTERS ?? mealPlanDefautMessage[0]?.listNameMinChar,
      })
      .refine((val) => val.length <= 20, {
        message:
          LIST_NAME_MAX_CHARACTERS ?? mealPlanDefautMessage[0]?.listNameMaxChar,
      })
      .refine(() => !regError, {
        message:
          SPECIAL_CHARACTER_NOT_ALLOWED ??
          mealPlanDefautMessage[0]?.specialCharNotAllowed,
      });

    const result = validationSchema.safeParse(value);
    if (!result.success) {
      return result.error.errors[0].message;
    }

    return "";
  };

  return { validateInput, valueWithoutInitalSpace };
};

export default useValidation;
